<script setup lang="ts">
// TODO: add hover effect, (might need to not use the logo-svg? because it should stretch)
withDefaults(
  defineProps<{
    link?: LinkProps
    makeContainerClickable?: boolean // be sure to put "position: relative" to the element that defines the clickable area
    dummy?: boolean // make the link appear as a link, but it's a <p>
    visible?: boolean
  }>(),
  {
    link: undefined,
    visible: true
  },
)
</script>

<template>
  <p
    v-if="dummy"
    class="group flex items-center gap-2 font-mono text-sm whitespace-nowrap uppercase"
  >
    <span
      class="logomark h-[.6lh] w-3 -skew-x-[20deg] bg-current transition-all duration-200 group-hover:w-7"
    />
    <span class="transition-transform duration-500 group-hover:translate-x-2">
      {{ link?.title }}
    </span>
  </p>

  <CommonBasicLink
    v-else
    :link="link"
    class="group flex items-center gap-2 font-mono text-sm uppercase"
    :class="makeContainerClickable ? 'after:absolute after:inset-0' : ''"
  >
    <span
      :class="{ 'sr-only': !visible }"
      class="logomark h-[.6lh] w-3 -skew-x-[20deg] bg-current transition-all duration-200 group-hover:w-7"
    />
    <span
      :class="{ 'sr-only': !visible }"
      class="transition-transform duration-500 group-hover:translate-x-2"
    >
      {{ link?.title }}
    </span>
  </CommonBasicLink>
</template>
